var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              default: "",
              name: "podcasts",
              label: _vm.$t(_vm.title_podcasts),
              icon: "fal fa-podcast"
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-md q-pb-xl q-mt-md",
              attrs: { name: "podcasts" }
            },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { class: _vm.filterClass },
                  [
                    _c("filter-podcasts", {
                      on: { changeFilter: _vm.changeFilter }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    class: _vm.contentClass,
                    staticStyle: { "min-height": "700px" }
                  },
                  [
                    _c(
                      "q-tabs",
                      {
                        staticClass: "shadow-1",
                        attrs: { align: "justify" },
                        model: {
                          value: _vm.tab,
                          callback: function($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab"
                        }
                      },
                      [
                        _c("q-tab", {
                          attrs: {
                            slot: "title",
                            name: "podcast",
                            icon: "fal fa-podcast",
                            label: _vm.$t(_vm.title_podcasts)
                          },
                          slot: "title"
                        }),
                        _c("q-tab", {
                          attrs: {
                            slot: "title",
                            name: "playlist",
                            icon: "fal fa-user-music",
                            label: _vm.$t("playlist")
                          },
                          slot: "title"
                        }),
                        _c(
                          "q-tab-pane",
                          {
                            staticClass: "q-px-lg q-pb-xl",
                            attrs: { name: "podcast", "keep-alive": "" }
                          },
                          [
                            _c("div", { staticClass: "row gutter-md" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "row gutter-md" },
                                  [
                                    _vm._l(_vm.podcasts, function(
                                      podcast,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "col-xs-12 col-sm-12"
                                        },
                                        [
                                          _vm.$q.platform.is.desktop
                                            ? _c("card-desktop", {
                                                key: podcast.id,
                                                attrs: { podcast: podcast },
                                                on: {
                                                  clickLike: _vm.clickLike,
                                                  clickStars: _vm.clickStars,
                                                  clickFavorite:
                                                    _vm.clickFavorite,
                                                  playPlaylist:
                                                    _vm.playPlaylist,
                                                  playAudio: _vm.playAudio
                                                }
                                              })
                                            : _vm._e(),
                                          _vm.$q.platform.is.mobile
                                            ? _c("card-mobile", {
                                                key: podcast.id,
                                                attrs: { podcast: podcast },
                                                on: {
                                                  clickLike: _vm.clickLike,
                                                  clickStars: _vm.clickStars,
                                                  clickFavorite:
                                                    _vm.clickFavorite,
                                                  playPlaylist:
                                                    _vm.playPlaylist,
                                                  playAudio: _vm.playAudio
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    }),
                                    _vm.podcasts.length === 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "col-xs-12 col-sm-12"
                                          },
                                          [
                                            _c(
                                              "q-card",
                                              [
                                                _c("q-card-title", [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "no_podcasts_found"
                                                        )
                                                      ) +
                                                      "\n                                                "
                                                  )
                                                ]),
                                                _c("q-card-separator"),
                                                this.search ||
                                                this.selected_areas.length >
                                                  0 ||
                                                this.favorite != "all" ||
                                                this.progress != "all"
                                                  ? _c("q-card-main", [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "searched_term_returned_no_results"
                                                            )
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ])
                                                  : _c("q-card-main", [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "there_are_no_podcasts_avaliable_at_the_moment"
                                                            )
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "q-tab-pane",
                          {
                            staticClass: "q-px-lg q-pb-xl",
                            attrs: { name: "playlist", "keep-alive": "" }
                          },
                          [
                            _c("div", { staticClass: "row gutter-md" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "row gutter-md" },
                                  [
                                    _vm._l(_vm.user_podcasts, function(
                                      podcast,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "col-xs-12 col-sm-12"
                                        },
                                        [
                                          _vm.$q.platform.is.desktop
                                            ? _c("card-desktop", {
                                                key: podcast.id,
                                                attrs: { podcast: podcast },
                                                on: {
                                                  clickLike: _vm.clickLike,
                                                  clickStars: _vm.clickStars,
                                                  clickFavorite:
                                                    _vm.clickFavorite,
                                                  playPlaylist:
                                                    _vm.playPlaylist,
                                                  playAudio: _vm.playAudio,
                                                  fetchUserPodcast:
                                                    _vm.fetchUserPodcast
                                                }
                                              })
                                            : _vm._e(),
                                          _vm.$q.platform.is.mobile
                                            ? _c("card-mobile", {
                                                key: podcast.id,
                                                attrs: { podcast: podcast },
                                                on: {
                                                  clickLike: _vm.clickLike,
                                                  clickStars: _vm.clickStars,
                                                  clickFavorite:
                                                    _vm.clickFavorite,
                                                  playPlaylist:
                                                    _vm.playPlaylist,
                                                  playAudio: _vm.playAudio,
                                                  fetchUserPodcast:
                                                    _vm.fetchUserPodcast
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    }),
                                    _vm.user_podcasts.length === 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "col-xs-12 col-sm-12"
                                          },
                                          [
                                            _c(
                                              "q-card",
                                              [
                                                _c("q-card-title", [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "no_podcasts_found"
                                                        )
                                                      ) +
                                                      "\n                                                "
                                                  )
                                                ]),
                                                _c("q-card-separator"),
                                                this.search ||
                                                this.selected_areas.length >
                                                  0 ||
                                                this.favorite != "all" ||
                                                this.progress != "all"
                                                  ? _c("q-card-main", [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "no_podcasts_found_with_this_filter"
                                                            )
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ])
                                                  : _c("q-card-main", [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "there_are_no_podcasts_avaliable_at_the_moment"
                                                            )
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm.playlist.length > 0
        ? _c(
            "q-page-sticky",
            { attrs: { position: "bottom-right", offset: [16, 16] } },
            [
              _c("q-btn", {
                staticClass: "animate-pop",
                attrs: { fab: "", color: "primary", icon: "fas fa-plus" },
                on: {
                  click: function($event) {
                    return _vm.clickPlaylist()
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("modal-stars", {
        attrs: { show: _vm.show_modal, podcast: _vm.podcast },
        on: { hideModal: _vm.hideModal }
      }),
      _c("addPodcastinPlaylist", {
        attrs: { show: _vm.show_modal_playlist },
        on: { hideModalListPlaylist: _vm.hideModalListPlaylist }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }